import * as yup from "yup";

const schema = yup
  .object({
    email: yup.string().required("Email is required").email("Invalid email")
  })
  .required();

export default schema;

